import React from "react";
import { Accordion } from "devextreme-react";
import SubMedidasItem from "./subMedidaItem";
import { dateFormat } from "../functions";

class AccordionSections extends React.PureComponent {

  render() {
    return (
      <React.Fragment>
        <Accordion
          dataSource={this.props.items.tblPlanSubMedida}
          defaultSelectedIndex={null}
          collapsible
          itemTitleComponent={(data) => (
            <div className="row">
              <div className="col-sm-6">
                <span className="PM-label-size">Acción</span>
                <p>{data.descripcion}</p>
              </div>
              <div className="col-sm-2 text-center">
                {
                  (data.estadoSubMedida === 1) ?
                    <div className="PM-plan-finalizada" style={{ marginTop: 3 }}>Tareas finalizadas</div>
                    :
                    <div className="PM-plan-pendientes" style={{ marginTop: 3 }}>{`${data.totalTareasPendientes} Tareas pendientes`}</div>
                }
              </div>
              <div className="col-sm-2 text-center">
                <span className="PM-label-size">Fecha inicio</span>
                <p>{dateFormat(data.fechaInicio)}</p>
              </div>
              <div className="col-sm-2 text-center">
                <span className="PM-label-size">Fecha limite</span>
                <p>{dateFormat(data.fechaLimite)}</p>
              </div>
            </div>
          )}
          itemComponent={(data) => <SubMedidasItem data={data} medidas={this.props.items}/>}
        />
      </React.Fragment>
    );
  }
}

export default AccordionSections;
